export default`
  min-width: initial;
  max-width: initial;
  position: relative;
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  padding: 0;
  left: 0;
  top: 0;
  background: rgb(218, 241, 238);


  &:hover {
    background: rgb(0, 215, 129);
  }
`;
